import type { FaireProductEntity } from "../../entity_types/product";

export const p_8jst837ndy: FaireProductEntity = {
  token: "p_8jst837ndy",
  type: "product",
  name: "Do Not Want To Do List Pad",
  brandName: "Primitives by Kathy",
  imageUrl:
    "https://cdn.faire.com/fastly/a86e8064eedd03a44c03aa1c1d8c5fcf9c0b7504f5b5314079c44b267589a2f4.jpeg",
  priceDollars: 2.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/96113c5a90c090ec92ec417bcd0f128fa4481fdba18c6756af5d2f8c847a3a7f.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
